import styled from 'styled-components'
import { warmPalette, neutralPalette, brandPalette } from '../../styles/abstracts/_variables.styles'

export const ActionSection = styled.section`
  padding: clamp(4rem, 8vw, 8rem) clamp(1.5rem, 10vw, 12rem);
  border-top: 0.25rem solid ${brandPalette.brass};
  background: ${warmPalette.primary};
  color: ${neutralPalette.white};
  text-align: center;
`

export const ActionEyebrow = styled.p`
  margin: 0 0 1rem;
  color: ${warmPalette.tertiary};
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`

export const ActionHeading = styled.h2`
  max-width: 18ch;
  margin: 0 auto;
  color: ${neutralPalette.white};
  font-size: clamp(2.2rem, 5vw, 4.5rem);
  font-weight: 400;
  line-height: 1.08;
`

export const ActionCopy = styled.p`
  max-width: 62ch;
  margin: 1.5rem auto 0;
  color: rgba(255, 255, 255, 0.84);
  font-size: clamp(1rem, 1.4vw, 1.18rem);
  line-height: 1.7;
`

export const ActionLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  margin-top: 2.5rem;
`

export const ActionLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  min-width: min(100%, 16rem);
  padding: 1rem 1.2rem;
  border: 1px solid ${({ $primary }) => ($primary ? warmPalette.tertiary : 'rgba(255, 255, 255, 0.55)')};
  border-radius: 0.2rem;
  background: ${({ $primary }) => ($primary ? warmPalette.tertiary : 'transparent')};
  color: ${({ $primary }) => ($primary ? warmPalette.primaryDark : neutralPalette.white)};
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-decoration: none;
  text-transform: uppercase;
  transition: background 180ms ease, color 180ms ease, transform 180ms ease;

  &:hover,
  &:focus-visible {
    background: ${neutralPalette.white};
    color: ${warmPalette.primaryDark};
    outline: none;
    transform: translateY(-2px);
  }
`
